import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { usePrevious } from 'react-use';
import { Grid } from 'semantic-ui-react';
import { nextCarouselItem } from '@/utils/resultsHelper';
import { addVocabularyRoleAction, deleteVocabularyRoleAction } from '../actions';
import VocabularyRoleActionForm from './VocabularyRoleActionForm';
import VocabularyRoleActionTable from '../components/VocabularyRoleActionTable';

// When a new item is added, switch focus to it.
const useActivateNewItem = (roleActions, setActiveRoleActionUUID) => {
  const previousRoleActions = usePrevious(roleActions);

  useEffect(() => {
    const isNewlyAdded = previousRoleActions?.length === roleActions.length - 1;

    if (isNewlyAdded) {
      setActiveRoleActionUUID(roleActions.at(-1).uuid);
    }
  }, [roleActions]);
};

const VocabularyRoleActions = ({
  addRoleActions,
  deleteRoleAction,
  roleActions,
  updateErrors,
}) => {
  const [activeRoleActionUUID, setActiveRoleActionUUID] = React.useState(roleActions?.[0]?.uuid);

  useActivateNewItem(roleActions, setActiveRoleActionUUID);

  const nextRoleActionUuid = (uuid) => (activeRoleActionUUID === uuid
    ? nextCarouselItem(roleActions, activeRoleActionUUID, 'uuid')
    : activeRoleActionUUID
  );

  const onDeleteClicked = (uuid) => {
    setActiveRoleActionUUID(roleActions.length === 1 ? undefined : nextRoleActionUuid(uuid));
    deleteRoleAction(uuid);
  };

  return (
    <Grid columns={2} className="min-h-500">
      <Grid.Column>
        <div className="h-100p relative overflow-x-hidden">
          <VocabularyRoleActionTable
            activeRoleActionUUID={activeRoleActionUUID}
            onActionSelected={(uuid) => setActiveRoleActionUUID(uuid)}
            onAddClicked={() => addRoleActions()}
            onDeleteClicked={onDeleteClicked}
            roleActions={roleActions}
            updateErrors={updateErrors}
          />
        </div>
      </Grid.Column>
      <Grid.Column>
        {activeRoleActionUUID && (
          <VocabularyRoleActionForm roleActionUUID={activeRoleActionUUID} updateErrors={updateErrors} />
        )}
      </Grid.Column>
    </Grid>
  );
};

const mapStateToProps = ({
  vocabularies: { activeVocabulary: { roleActions, updateErrors } },
}) => ({ roleActions, updateErrors });

const mapDispatchToProps = {
  addRoleActions: addVocabularyRoleAction,
  deleteRoleAction: deleteVocabularyRoleAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(VocabularyRoleActions);
